import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { map } from "rxjs";

import { Constants } from "../../shared/constants/constants";
import { AdaaHelper } from "../utils";
import { MainInterceptorService } from "./main-interceptor-service";

export function mainInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const mainInterceptorService = inject(MainInterceptorService);

  //Setting hardwareUuid
  const hardwareUuid = AdaaHelper.getLocalStorage(Constants.localStorageKeys.hardwareUuid);
  if (!AdaaHelper.isDefinedAndNotEmpty(hardwareUuid))
    AdaaHelper.setLocalStorage(Constants.localStorageKeys.hardwareUuid, generateHardwareUUID(), "string");

  return next(req).pipe(map((event: HttpEvent<unknown>) => mainInterceptorService.interceptorMapFn(event)));
}

function generateHardwareUUID(): string {
  return crypto.randomUUID();
}
